import { AxiosError } from 'axios';
import useSWRMutation from 'swr/mutation';

import { camelizeKeys, WithStatusT } from '@consumer-frontend/nc-utils';

import {
  apiEndpoints,
  unauthenticatedFetchers,
} from '../lib';

export type VerifyEmailCodeRequestT = {
  code: string;
};

export type RawVerifyEmailCodeResponseT = {
  token?: {
    access_token?: string;
    refresh_token?: string;
  };
};

export type VerifyEmailCodeResponseT = {
  token?: {
    accessToken?: string;
    refreshToken?: string;
  };
};

export type VerifyEmailCodeErrorT = {
  error_type?: 'CACHE_MISS';
};

export const useVerifyEmailCode = () => {
  const {
    error,
    isMutating,
    reset,
    trigger: verifyEmailCode,
  } = useSWRMutation<
    WithStatusT<VerifyEmailCodeResponseT>,
    AxiosError<VerifyEmailCodeErrorT>,
    string,
    VerifyEmailCodeRequestT
  >(
    apiEndpoints.apply.v2.verifyEmailCode,
    async (url, { arg }) => {
      const data = await unauthenticatedFetchers.post<VerifyEmailCodeRequestT>(url, { arg }) as RawVerifyEmailCodeResponseT;

      return camelizeKeys(data, { deep: true }) as WithStatusT<VerifyEmailCodeResponseT>;
    },
    { throwOnError: false },
  );

  return {
    error,
    isMutating,
    reset,
    verifyEmailCode,
  };
};
